import React from 'react';
import { Card, CardBody } from '../common';

export const WaitingForComposition = () => {
  return (
    <Card>
      <CardBody>
        <div className="text-center py-8">
          <div className="mb-4">
            <svg
              className="w-16 h-16 mx-auto text-primary-400 animate-pulse"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
          </div>

          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            The GM is Composing
          </h3>

          <p className="text-gray-600 max-w-md mx-auto">
            The GM is weaving player submissions into the next passage of the story.
            You'll be notified when voting begins.
          </p>

          <div className="mt-6 pt-6 border-t">
            <p className="text-sm text-gray-500">
              While you wait, you can review previous passages in the Story tab.
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
